// Citation chips displayed below an AI-generated section's text (ticket 8267).
// Each chip shows [N] with the source file info, linked to the section's sources.

import { extractPageNumber } from "@/features/chat/citations";
import type { SectionCitation, SectionSource } from "./types";

interface SectionCitationsProps {
  citations: SectionCitation[];
  sources: SectionSource[];
}

const SectionCitations = ({ citations, sources }: SectionCitationsProps) => {
  const sourceById = new Map(sources.map((s) => [s.id, s]));

  return (
    <div className="mt-3 flex flex-wrap gap-1.5 border-t pt-3">
      {citations.map((c) => {
        const source = c.source_id ? sourceById.get(c.source_id) : undefined;
        const page = extractPageNumber(c.sourcepage);
        const label = source?.label || c.sourcefile.split("/").pop() || `Source ${c.id}`;
        return (
          <span
            key={c.id}
            className="inline-flex items-center gap-1 rounded-full border bg-muted/50 px-2.5 py-0.5 text-xs text-muted-foreground"
            title={c.content}
          >
            <strong className="font-semibold text-brand-navy">[{c.id}]</strong>
            <span className="max-w-[12rem] truncate">{label}</span>
            {page !== null && <span className="text-muted-foreground/60">p.{page}</span>}
          </span>
        );
      })}
    </div>
  );
};

export default SectionCitations;
